import { localisedValue } from "utils"

const hierarchicalUnitLocationTransformer = unitLocationsArray => {
  const transformedArray = unitLocationsArray.map(item => {
    return {
      title: localisedValue({ object: item, key: "name" }),
      value: item?.id?.toString(),
      key: item?.id?.toString(),
      ...(item?.children?.length && { children: hierarchicalUnitLocationTransformer(item?.children) }),
    }
  })
  return transformedArray
}

export default hierarchicalUnitLocationTransformer
